/**
 * Detects the format of the given string.
 * Returns 'json', 'xml', 'html', or 'unknown'.
 * @param {string} text 
 * @returns {string}
 */
export const detectFormat = (text) => {
    const trimmed = text.trim();

    if (!trimmed) return 'unknown';

    // JSON detection
    if ((trimmed.startsWith('{') && trimmed.endsWith('}')) ||
        (trimmed.startsWith('[') && trimmed.endsWith(']'))) {
        try {
            JSON.parse(trimmed);
            return 'json';
        } catch (e) {
            // It might be invalid JSON, but if it looks like JSON, we route to JSON editor
            return 'json';
        }
    }

    // XML/HTML detection
    if (trimmed.startsWith('<') && trimmed.endsWith('>')) {
        if (trimmed.toLowerCase().includes('<!doctype html') || trimmed.toLowerCase().includes('<html')) {
            return 'html';
        }
        return 'xml';
    }

    return 'unknown';
};
